import useResizeObserver from "@react-hook/resize-observer";
import { useEffect, useState, MutableRefObject } from "react";

export const useProductPageHeaderHeight = (
    headerRef: MutableRefObject<HTMLDivElement | null>,
    scrollableContainerRef?: MutableRefObject<HTMLDivElement | null>
) => {
    const scrollableContainerDom = scrollableContainerRef?.current;
    const [headerHeight, setHeaderHeight] = useState<number>(0);
    const headerDomNode = headerRef.current;
    const stickyAttribute = headerDomNode?.getAttribute("data-is-sticky");
    if (headerDomNode && stickyAttribute === null) {
        throw new Error("Header 'data-is-sticky' is required!");
    }
    const withStickyHeader = stickyAttribute === "true";

    useEffect(() => {
        let disabled = false;
        const onScroll = () => {
            if (!headerDomNode) return;
            const { top, bottom } = headerDomNode.getBoundingClientRect();
            const hasReachedTop = top === 0;
            if (!disabled || !hasReachedTop) {
                disabled = false;
                setHeaderHeight(bottom - top);
            }
            if (hasReachedTop) disabled = true;
        };
        (scrollableContainerDom ?? window).addEventListener("scroll", onScroll);
        return () => (scrollableContainerDom ?? window).removeEventListener("scroll", onScroll);
    }, [headerDomNode, scrollableContainerDom]);

    useResizeObserver(headerRef, (entry) => {
        const { bottom, top } = entry.target.getBoundingClientRect();
        setHeaderHeight(bottom - top);
    });

    return { withStickyHeader, headerHeight };
};
